import type { SxProps, Theme } from "@mui/material/styles";

export const connectorLineSx: SxProps<Theme> = {
  display: { xs: "none", sm: "block" },
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  pointerEvents: "none",
  zIndex: 0,
};

export const connectorLineMobileSx: SxProps<Theme> = {
  display: { xs: "block", sm: "none" },
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  pointerEvents: "none",
  zIndex: 0,
};
